export const MAX_NOTIFICATIONS_COUNT = 4;

export const MAX_NOTIFICATIONS_TIME_VALUE = 1440;